(function() {
  var AccessController, ChemicalsValidator,
    bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  AccessController = App.loadClass('admin::Angular/AccessController');

  ChemicalsValidator = App.loadClass('admin::Angular/Tools/ChemicalsValidator');

  exports.ChemicalsController = (function(superClass) {
    extend(ChemicalsController, superClass);

    function ChemicalsController(scope, transitions, modal, chemicalsService, q, loading, http) {
      var clonableSpan, hot, self;
      this.scope = scope;
      this.transitions = transitions;
      this.modal = modal;
      this.chemicalsService = chemicalsService;
      this.q = q;
      this.loading = loading;
      this.http = http;
      this.disableCellsThatNeedTo = bind(this.disableCellsThatNeedTo, this);
      this.beforeValidate = bind(this.beforeValidate, this);
      this.sanitizeChemicals = bind(this.sanitizeChemicals, this);
      this.saveChemicals = bind(this.saveChemicals, this);
      this.buildParentData = bind(this.buildParentData, this);
      this.loadChemicals = bind(this.loadChemicals, this);
      this.doCategoryValidation = bind(this.doCategoryValidation, this);
      this.doModeOfActionValidation = bind(this.doModeOfActionValidation, this);
      this.doWindSpeedValidation = bind(this.doWindSpeedValidation, this);
      this.doNameValidation = bind(this.doNameValidation, this);
      ChemicalsController.__super__.constructor.call(this, 'chemicals', this.http);
      clonableSpan = document.createElement('SPAN');
      hot = window.Handsontable;
      this.scope.chemRenderer = (function(_this) {
        return function(instance, td, row, col, prop, value, cellProperties) {
          var chemical, eventManager, innerSpan, ref, ref1, ref2, wrapperSpan;
          chemical = _this.scope.chemicals[row];
          hot.Dom.empty(td);
          eventManager = hot.eventManager(instance);
          wrapperSpan = clonableSpan.cloneNode(false);
          wrapperSpan.className = 'clickable text-center block label';
          innerSpan = clonableSpan.cloneNode(false);
          innerSpan.className = 'fa';
          wrapperSpan.appendChild(innerSpan);
          if ((ref = chemical.children) != null ? ref.length : void 0) {
            wrapperSpan.classList.add('label-info');
            innerSpan.classList.add('fa-pencil');
          } else {
            wrapperSpan.classList.add('label-success');
            innerSpan.classList.add('fa-plus');
          }
          if (((ref1 = chemical.parents) != null ? ref1.length : void 0) || (chemical.id == null)) {
            wrapperSpan.classList.add('btn', 'disabled');
          }
          if ((ref2 = chemical.parents) != null ? ref2.length : void 0) {
            wrapperSpan.title = 'Cannot add children when already a child';
          }
          if (chemical.id == null) {
            wrapperSpan.title = 'Cannot add children until after new chemical is saved';
          }
          eventManager.addEventListener(wrapperSpan, 'click', function(event) {
            var ref3;
            if (((ref3 = chemical.parents) != null ? ref3.length : void 0) || (chemical.id == null)) {
              return;
            }
            return _this.modal.open({
              windowClass: 'medium_dialog',
              templateUrl: 'backend/admin/new-tools/chemicals/children-dialog',
              controller: 'Tools.Controllers.ChemicalsChildrenController',
              resolve: {
                chemical: function() {
                  return chemical;
                },
                chemicals: function() {
                  return _this.scope.chemicals;
                }
              }
            }).result.then(function(chemical) {
              _this.scope.chemicals[row] = chemical;
              _this.buildParentData();
              return _this.disableCellsThatNeedTo();
            });
          });
          eventManager.addEventListener(wrapperSpan, 'mousedown', function(event) {
            return hot.helper.stopPropagation(event);
          });
          td.appendChild(wrapperSpan);
          return td;
        };
      })(this);
      this.scope.fullpage = true;
      this.scope.title = 'Chemicals';
      this.scope.chemicals = [];
      this.scope.chemicalsNotChanged = false;
      this.scope.loadChemicals = this.loadChemicals;
      this.scope.saveChemicals = this.saveChemicals;
      this.validator = null;
      this.scope.validateName = this.doNameValidation;
      this.scope.validateWindSpeed = this.doWindSpeedValidation;
      this.scope.validateModeOfAction = this.doModeOfActionValidation;
      this.scope.validateCategory = this.doCategoryValidation;
      this.loadChemicals();
      self = this;
      this.scope.hot_settings = {
        currentColClassName: 'highlighted',
        currentRowClassName: 'highlighted',
        allowInsertColumn: false,
        allowRemoveColumn: false,
        minSpareRows: 1,
        allowInsertRow: true,
        allowRemoveRow: false,
        rowHeaders: false,
        columnHeaders: true,
        fixedRowsTop: 0,
        beforeValidate: this.beforeValidate,
        allowInvalid: true,
        dataSchema: {
          is_product: true
        },
        afterInit: function() {
          self.hot = this;
          self.validator = new ChemicalsValidator(this, self.scope.chemicals);
          return self.disableCellsThatNeedTo();
        }
      };
    }

    ChemicalsController.prototype.doNameValidation = function(cell, callback) {
      return this.validator.validateName(cell, callback);
    };

    ChemicalsController.prototype.doWindSpeedValidation = function(cell, callback) {
      return this.validator.validateWindSpeed(cell, callback);
    };

    ChemicalsController.prototype.doModeOfActionValidation = function(cell, callback) {
      return this.validator.validateModeOfAction(cell, callback);
    };

    ChemicalsController.prototype.doCategoryValidation = function(cell, callback) {
      return this.validator.validateCategory(cell, callback);
    };

    ChemicalsController.prototype.loadChemicals = function() {
      return this.chemicalsService.getAllChemicals().then((function(_this) {
        return function(response) {
          _.merge(_this.scope.chemicals, response.data);
          if (_this.scope.chemicals[_this.scope.chemicals.length - 1].name) {
            _this.scope.chemicals.push({
              is_product: true
            });
          }
          return _this.buildParentData();
        };
      })(this));
    };

    ChemicalsController.prototype.buildParentData = function() {
      var chemical, i, len, ref, ref1, results;
      ref = this.scope.chemicals;
      results = [];
      for (i = 0, len = ref.length; i < len; i++) {
        chemical = ref[i];
        if ((ref1 = chemical.children) != null ? ref1.length : void 0) {
          chemical.max_wind_speed = chemical.children.map(function(child) {
            return child.max_wind_speed;
          }).reduce(function(min, child) {
            if (min === null) {
              return child;
            }
            if (child === null) {
              return min;
            }
            return Math.min(min, child);
          }, 2e308);
          if (chemical.max_wind_speed === 2e308) {
            results.push(chemical.max_wind_speed = null);
          } else {
            results.push(void 0);
          }
        } else {
          results.push(void 0);
        }
      }
      return results;
    };

    ChemicalsController.prototype.saveChemicals = function() {
      this.loading.overMap('Saving...');
      this.validator.is_valid = true;
      this.validator.validation_messages = [];
      this.hot.validateCells(_.debounce((function(_this) {
        return function() {
          var $save_promise, sanitizedChemicals;
          if (_this.validator.is_valid) {
            sanitizedChemicals = _this.sanitizeChemicals(_this.scope.chemicals);
            $save_promise = _this.loadScopeData(_this.chemicalsService.actuallySaveChemicals(sanitizedChemicals));
            return $save_promise.then(function(promise_result) {
              return _this.loadChemicals().then(function() {
                _this.loading.hideAll();
                return _this.clearAlert();
              });
            });
          } else {
            _this.setAlert({
              type: 'error'
            }, _this.validator.validation_messages);
            return _this.loading.hideAll();
          }
        };
      })(this), 1000));
    };

    ChemicalsController.prototype.sanitizeChemicals = function(unsanitizedChemicals) {
      var i, len, ref, sanitizedChemicals, unsanitizedChemical;
      sanitizedChemicals = [];
      for (i = 0, len = unsanitizedChemicals.length; i < len; i++) {
        unsanitizedChemical = unsanitizedChemicals[i];
        if (unsanitizedChemical.name !== '' && unsanitizedChemical.name !== null) {
          if (unsanitizedChemical.mode_of_action === '') {
            unsanitizedChemical.mode_of_action = null;
          }
          if (unsanitizedChemical.max_wind_speed === '') {
            unsanitizedChemical.max_wind_speed = null;
          }
          if ((ref = unsanitizedChemical.children) != null ? ref.length : void 0) {
            unsanitizedChemical.mode_of_action = null;
          }
          sanitizedChemicals.push(unsanitizedChemical);
        }
      }
      return sanitizedChemicals;
    };

    ChemicalsController.prototype.beforeValidate = function(value, row, prop, source) {
      var cell, rowObject;
      cell = {
        value: value,
        row: row,
        prop: prop
      };
      if (row === this.hot.countRows() - 1) {
        cell.ignore = true;
      }
      rowObject = this.hot.getSourceDataAtRow(row);
      if (!rowObject.name && !rowObject.category && !rowObject.mode_of_action && !rowObject.epa_number && !rowObject.max_wind_speed && !rowObject.data_source) {
        cell.ignore = true;
      }
      return cell;
    };

    ChemicalsController.prototype.disableCellsThatNeedTo = function() {
      return this.hot.updateSettings({
        cells: (function(_this) {
          return function(row, col, prop) {
            var cellProperties, ref, ref1, ref2;
            cellProperties = {};
            if ((ref = _this.scope.chemicals[row].children) != null ? ref.length : void 0) {
              if (prop === 'category' || prop === 'mode_of_action' || prop === 'max_wind_speed') {
                cellProperties.readOnly = true;
              }
            }
            if (prop === 'category') {
              if (((ref1 = _this.scope.chemicals[row].parents) != null ? ref1.length : void 0) || ((ref2 = _this.scope.chemicals[row].children) != null ? ref2.length : void 0)) {
                cellProperties.readOnly = true;
              } else {
                cellProperties.readOnly = false;
              }
            }
            return cellProperties;
          };
        })(this)
      });
    };

    return ChemicalsController;

  })(AccessController);

}).call(this);
